import type { JSONObject } from 'lib/types';

export const EVENT_KINDS = {
  CREATE_COMMENT: 'create_comment',
  CREATE_SUPPORTING_FILE: 'create_supporting_file',
  DESTROY_SUPPORTING_FILE: 'destroy_supporting_file',
  COMPLETION_CORRECT: 'completion_correct',
  COMPLETION_INCORRECT: 'completion_incorrect',
  COMPLETION_REVERTED: 'completion_reverted',
  IC_SLOT_UNCONFIRMED: 'interest_certification.slot_unconfirmed',
  IC_AUTO_CONFIRM_RECOMPUTED: 'interest_certification.auto_confirm_recomputed',
  // Bugs & feature requests. Without these three the rows fall through to the
  // payload.content branch below — which our payloads have no `content` key for, so they
  // rendered as a header with no body at all, losing the whole triage narrative.
  RESOLVE_REPORT: 'resolve_report',
  REOPEN_REPORT: 'reopen_report',
  JIRA_COMMENT: 'jira_comment',
  JIRA_TEAM: 'jira_team',
  JIRA_STATUS: 'jira_status',
  JIRA_MOVED: 'jira_moved',
} as const;

export type EventKind = (typeof EVENT_KINDS)[keyof typeof EVENT_KINDS];

export interface EventRendererProps {
  kind: string;
  createdBy: string;
  createdAt: string;
  payload: JSONObject;
}
